import React, { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { updateCustomerSettings, getCustomerSettings } from '../../../actions/customers'
// Styles
import './index.scss'

// Utils
import { translation } from '../../../utils/helpers'

// Elements
import Panel from '../../elements/panel'
import Switch from '../../elements/switch'

class DealerSettings extends Component {

  constructor (props) {
    super(props)
    this.state = {
      CustomerId: 0,
      EvaluationRequired: undefined,
      WPPriceApprovalRequired: undefined,
      WPAddonApprovalRequired: undefined,
      AddonSaleSeparate: undefined,
      TransferMaterialSalaryTotal: false,
      WPShowReferredTo: undefined,
      canChange: false
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getCustomer(this.props)
  }
  getCustomer (props) {
    this.setState({
      CustomerId: 0,
      EvaluationRequired: undefined,
      WPPriceApprovalRequired: undefined,
      WPAddonApprovalRequired: undefined,
      AddonSaleSeparate: undefined,
      TransferMaterialSalaryTotal: false,
      WPShowReferredTo: undefined,
      canChange: false // Block change while loading
    }, () => {
      if (props.CustomerId !== undefined) {
        let customerId = props.CustomerId
        props.getCustomerSettings(customerId).then((res) => {
          console.log('props after get', props)
          this.setState({
            CustomerId: res.data.CustomerId,
            EvaluationRequired: res.data.EvaluationRequired,
            WPPriceApprovalRequired: res.data.WPPriceApprovalRequired,
            WPAddonApprovalRequired: res.data.WPAddonApprovalRequired,
            AddonSaleSeparate: res.data.AddonSaleSeparate,
            TransferMaterialSalaryTotal: res.data.TransferMaterialSalaryTotal,
            WPShowReferredTo: res.data.WPShowReferredTo,
            canChange: true
          })
        }, (err) => {
          console.log(err)
        })
      }
    })
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.CustomerId !== nextProps.CustomerId) {
      this.getCustomer(nextProps)
    }
  }
  onChange (e) {
    e.persist()
    let value = e.target.value
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }

    this.setState({
      [e.target.name]: value
    }, () => {
      if (e.target.type === 'checkbox') {
        this.onBlur(e)
      }
    })
  }

  onBlur (e) {
    this.setState({
      canChange: false // Block change while loading
    }, () => {
      if (this.state.CustomerId > 0) {
        let data = {
          CustomerId: this.state.CustomerId,
          EvaluationRequired: this.state.EvaluationRequired,
          WPPriceApprovalRequired: this.state.WPPriceApprovalRequired,
          WPAddonApprovalRequired: this.state.WPAddonApprovalRequired,
          AddonSaleSeparate: this.state.AddonSaleSeparate,
          TransferMaterialSalaryTotal: this.state.TransferMaterialSalaryTotal,
          WPShowReferredTo: this.state.WPShowReferredTo
        }
        this.props.updateCustomerSettings(data).then((res) => {
          let dat = res.data
          this.setState({
            CustomerId: dat.CustomerId,
            EvaluationRequired: dat.EvaluationRequired,
            WPPriceApprovalRequired: dat.WPPriceApprovalRequired,
            WPAddonApprovalRequired: dat.WPAddonApprovalRequired,
            AddonSaleSeparate: dat.AddonSaleSeparate,
            TransferMaterialSalaryTotal: dat.TransferMaterialSalaryTotal,
            WPShowReferredTo: dat.WPShowReferredTo,
            canChange: true
          })

          // window.toastr.success(translation('14746'), translation('13424'))
        }, (err) => {
          // Toastr
          if (err.response !== undefined && err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
            let errors = err.response.data.Errors
            let errText = ''
            for (let i = 0; i < errors.length; i++) {
              let dictKey = errors[i].DictionaryKey
              errText += '<br/>' + translation(dictKey)
            }
            window.toastr.error(translation(errText), translation('216'))
          } else {
            window.toastr.error(translation('13465'), translation('216'))
          }
          this.getCustomer(this.props)
        })
      }
    })
  }
  render () {
    return (
      <Panel title={translation('6')}>
        <Switch onChange={this.onChange} name='EvaluationRequired' checked={this.state.EvaluationRequired} labelText={translation('14729')} disabled={!this.state.canChange} />
        <Switch onChange={this.onChange} name='WPPriceApprovalRequired' checked={this.state.WPPriceApprovalRequired} labelText={translation('2044')} disabled={!this.state.canChange} />
        <Switch onChange={this.onChange} name='WPAddonApprovalRequired' checked={this.state.WPAddonApprovalRequired} labelText={translation(16824)} disabled={!this.state.canChange} />
        <Switch onChange={this.onChange} name='AddonSaleSeparate' checked={this.state.AddonSaleSeparate} labelText={translation('2092')} disabled={!this.state.canChange} />
        <Switch onChange={this.onChange} name='TransferMaterialSalaryTotal' checked={this.state.TransferMaterialSalaryTotal} labelText={translation('14943')} disabled={!this.state.canChange} />
        <Switch onChange={this.onChange} name='WPShowReferredTo' checked={this.state.WPShowReferredTo} labelText={translation('14931')} helpText={translation('14933')} disabled={!this.state.canChange} />
      </Panel>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  updateCustomerSettings,
  getCustomerSettings
})(DealerSettings)



// WEBPACK FOOTER //
// ./src/app/shared/components/DealerSettings/index.js